module.exports = function(vars) {
var __t, __p = '';
__p += '<div style="position: absolute; top: 43%; right: 41%; text-align: center;" class="loading">\n  <img style="width: 38px;left: -5px;position: relative;" src="/images/loading.gif" alt="">\n  <p> Loading ...</p>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/loading.ejs